/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DecreaseCreditRequest } from '../models/DecreaseCreditRequest';
import type { IncreaseCreditRequest } from '../models/IncreaseCreditRequest';
import type { ViewBalanceResponse } from '../models/ViewBalanceResponse';
import type { ViewEntityCommissionBalanceResponse } from '../models/ViewEntityCommissionBalanceResponse';
import type { ViewStatementResponse } from '../models/ViewStatementResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminTreasuryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public increaseCredit({
        requestBody,
    }: {
        requestBody: IncreaseCreditRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/treasury/credit/increase',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public decreaseCredit({
        requestBody,
    }: {
        requestBody: DecreaseCreditRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/treasury/credit/decrease',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public withdrawCommission({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/treasury/commission/withdrawn',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ViewStatementResponse OK
     * @throws ApiError
     */
    public viewStatement({
        page,
        size,
        ledgerOwner,
        feature,
        type,
        status,
        search,
        startDate,
        endDate,
        sortOrder,
        ledgerOwnerId,
    }: {
        page: number,
        size: number,
        ledgerOwner: 'SHOP' | 'REVENUE' | 'THIRD_PARTY' | 'CLEARING' | 'BANKS' | 'FINANCIER',
        feature?: 'SHOP_CREDIT' | 'CHECK_IMEI' | 'CHECK_SLIP' | 'OTHER',
        type?: 'SERVICE_CONSUMPTION' | 'CURRENCY_CONVERSION' | 'THIRD_PARTY_API_CALL' | 'TOP_UP' | 'INCREASE_CREDIT' | 'DECREASE_CREDIT' | 'REFUND' | 'MIDDLEMAN_FEE' | 'COMMISSION_WITHDRAWAL' | 'PROFIT',
        status?: 'SUCCESS' | 'FAILED' | 'PENDING',
        search?: string,
        startDate?: string,
        endDate?: string,
        sortOrder?: string,
        ledgerOwnerId?: string,
    }): CancelablePromise<ViewStatementResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/treasury/statement',
            query: {
                'feature': feature,
                'type': type,
                'status': status,
                'search': search,
                'startDate': startDate,
                'endDate': endDate,
                'sortOrder': sortOrder,
                'page': page,
                'size': size,
                'ledgerOwner': ledgerOwner,
                'ledgerOwnerId': ledgerOwnerId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ViewBalanceResponse OK
     * @throws ApiError
     */
    public viewBalance({
        ledgerOwner,
        ledgerOwnerId,
        type,
    }: {
        ledgerOwner: 'SHOP' | 'REVENUE' | 'THIRD_PARTY' | 'CLEARING' | 'BANKS' | 'FINANCIER',
        ledgerOwnerId?: string,
        type?: 'SERVICE_CONSUMPTION' | 'CURRENCY_CONVERSION' | 'THIRD_PARTY_API_CALL' | 'TOP_UP' | 'INCREASE_CREDIT' | 'DECREASE_CREDIT' | 'REFUND' | 'MIDDLEMAN_FEE' | 'COMMISSION_WITHDRAWAL' | 'PROFIT',
    }): CancelablePromise<ViewBalanceResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/treasury/statement/balance',
            query: {
                'ledgerOwner': ledgerOwner,
                'ledgerOwnerId': ledgerOwnerId,
                'type': type,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ViewEntityCommissionBalanceResponse OK
     * @throws ApiError
     */
    public viewCommissionBalance({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ViewEntityCommissionBalanceResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/treasury/statement/balance/commission',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
